import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const industries = [
  {
    title: "HVAC & Home Services",
    path: "/hvac",
    desc: "Capture high-ticket emergency calls while you are on a ladder or under a vehicle. Never lose a plumbing or HVAC job to a competitor again.",
    icon: "Tool",
    color: "bg-orange-500/10",
    iconColor: "text-orange-500"
  },
  {
    title: "Dentists & Clinics",
    path: "/dentists",
    desc: "Stop overwhelming your front desk during morning rush hours and never miss new patient intake. Secure, professional, and compliant.",
    icon: "Heart",
    color: "bg-blue-500/10",
    iconColor: "text-blue-500"
  },
  {
    title: "Law Firms & Legal",
    path: "/legal",
    desc: "Secure high-value commission and retainer leads instantly before they contact the next listing or attorney on Google.",
    icon: "Briefcase",
    color: "bg-emerald-500/10",
    iconColor: "text-emerald-500"
  }
];

const Industries = () => {
  return (
    <section className="py-24 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Built for High-Intent Local Services</h2>
          <p className="text-slate-400 max-w-2xl mx-auto">Click an industry below to see how we tailor our AI for your specific business needs.</p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {industries.map((ind, idx) => (
            <Link 
              key={idx} 
              to={ind.path}
              className="group flex flex-col items-center text-center p-8 bg-slate-900/50 border border-slate-800 rounded-3xl hover:bg-slate-800 hover:border-blue-500/50 transition-all duration-300"
            >
              <div className={`w-16 h-16 ${ind.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                <SafeIcon name={ind.icon} className={`text-3xl ${ind.iconColor}`} />
              </div>
              <h3 className="text-xl font-bold text-white mb-3 group-hover:text-blue-400 transition-colors">{ind.title}</h3>
              <p className="text-slate-400 mb-6">{ind.desc}</p>
              <span className="text-blue-400 font-semibold flex items-center gap-2 group-hover:gap-3 transition-all">
                Learn More <SafeIcon name="ArrowRight" className="text-sm" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;